import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import {
  ResponsiveModal,
  ResponsiveModalContent,
  ResponsiveModalDescription,
  ResponsiveModalHeader,
  ResponsiveModalTitle,
} from '@/components/ResponsiveModal/ResponsiveModal'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'

interface RefineSearchDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  title: string
  description: string
  placeholder: string
  value: string
  onSubmit: (value: string) => void
}

export const RefineSearchDialog = ({
  open,
  onOpenChange,
  title,
  description,
  placeholder,
  value,
  onSubmit,
}: RefineSearchDialogProps) => {
  const { t } = useTranslation()
  const [draft, setDraft] = useState(value)

  useEffect(() => {
    if (open) setDraft(value)
  }, [open, value])

  const handleSubmit = () => {
    onSubmit(draft.trim())
    onOpenChange(false)
  }

  const handleCancel = () => onOpenChange(false)

  return (
    <ResponsiveModal open={open} onOpenChange={onOpenChange}>
      <ResponsiveModalContent className="sm:max-w-[456px] bg-baseColor border-0 p-4 sm:rounded-2xl gap-6">
        <ResponsiveModalHeader className="space-y-0 gap-3">
          <ResponsiveModalTitle className="text-xl font-medium text-neutralColor text-left">
            {title}
          </ResponsiveModalTitle>
          <ResponsiveModalDescription className="text-base text-neutralColor text-left">
            {description}
          </ResponsiveModalDescription>
        </ResponsiveModalHeader>

        <Input
          value={draft}
          onChange={(e) => setDraft(e.target.value)}
          placeholder={placeholder}
          onKeyDown={(e) => {
            if (e.key === 'Enter') handleSubmit()
          }}
          autoFocus
          className="h-[46px]"
        />

        <div className="flex justify-end gap-4">
          <Button variant="secondary" onClick={handleCancel}>
            {t('dashboard.runReport.searchResults.cancel')}
          </Button>
          <Button onClick={handleSubmit}>
            {t('dashboard.runReport.searchResults.search')}
          </Button>
        </div>
      </ResponsiveModalContent>
    </ResponsiveModal>
  )
}
